import * as React from 'react';
import useStyles from 'src/styles/di-theme';
import classNames from 'classnames';
import {
	IconButton,
	Box,
	Typography,
	BDSProvider,
} from '@barracuda-internal/bds-core-v2';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import IOSSwitch from './IOSSwitch';
import { SideDetailContext } from './SideDetailPanel';
import Tooltip from '@mui/material/Tooltip';
import useDetectionStyles from './styles/detection';
export default function CenteredIcons({
	zoom,
	onZoomIn,
	onZoomOut,
	total,
	current,
	onUp,
	onDown,
	classifier = '',
	setShowRedactions,
	isViewable,
	isCropEnabled,
}) {
	const backgroundColor = '#2B2929';
	const classes = useStyles();
	const { showRedactions } = React.useContext(SideDetailContext);
	const customClasses = useDetectionStyles();
	const handleSwitchToggle = () => {
		setShowRedactions(!showRedactions);
	};
	
	return (
		<BDSProvider>
			<div style={{ backgroundColor }}>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'row',
						alignItems: 'center',
						opacity: 0.9,
						padding: '4px',
					}}
					className={
						!isCropEnabled
							? classNames(classes['d_visible'])
							: classNames(classes['d_hidden'])
					}
				>
					{classifier != '' ? (
						<>
							<Typography
								className={classNames(
									classes['pl_2'],
									customClasses['white'],
								)}
							>
								{classifier.length > 19 ? (
									<Tooltip
									title={classifier}
									slotProps={{
										tooltip: {
											sx: {
												backgroundColor: '#2B2929',
												color: '#fff',
												border: 'none',
											},
										},
									}}
								>
										<Typography
											variant="body1"
											component="span"
											className={classNames(
												classes['d_inline'],
												classes['cursor_pointer'],
												customClasses['white'],
											)}
										>
											{classifier.slice(0, 16) + '... '}
										</Typography>
									</Tooltip>
								) : (
									classifier
								)}
							</Typography>
							<IconButton
								size="small"
								onClick={() => {
									onUp();
								}}
								className={classNames(classes['pl_2'])}
							>
								<KeyboardArrowUpRoundedIcon
									fontSize="small"
									className={customClasses['white']}
								/>
							</IconButton>
							<Typography
								className={classNames(
									classes['pl_1'],
									classes['pr_1'],
									customClasses['white'],
								)}
							>
								{current} of {total}
							</Typography>
							<IconButton
								size="small"
								onClick={() => {
									onDown();
								}}
							>
								<KeyboardArrowDownIcon
									fontSize="small"
									className={customClasses['white']}
								/>
							</IconButton>
						</>
					) : null}
					<Box
						sx={{
							flexGrow: 1,
						}}
					></Box>
					{isViewable && (
						<Box
							className={
								customClasses[
									'doc-preview-redactions-label-box'
								]
							}
						>
							{' '}
							<Typography
								className={classNames(
									classes['p_1'],
									customClasses['white'],
								)}
							>
								Redactions
							</Typography>
							<Tooltip
								title={
									showRedactions
										? `Redaction: On`
										: `Redaction: Off`
								}
								slotProps={{
									tooltip: {
										sx: {
											backgroundColor: '#2B2929',
											color: '#fff',
											border: 'none',
										},
									},
								}}
							>
								<div>
									<IOSSwitch
										checked={showRedactions}
										onChange={handleSwitchToggle}
									/>
								</div>
							</Tooltip>
						</Box>
					)}

					<IconButton
						size="small"
						onClick={() => {
							onZoomOut();
						}}
					>
						<RemoveIcon
							fontSize="small"
							className={customClasses['white']}
						/>
					</IconButton>
					<Typography className={customClasses['white']}>
						{zoom}%
					</Typography>
					<IconButton
						size="small"
						onClick={() => {
							onZoomIn();
						}}
						className={classNames(classes['pr_2'])}
					>
						<AddIcon
							fontSize="small"
							className={customClasses['white']}
						/>
					</IconButton>
				</Box>
			</div>
		</BDSProvider>
	);
}
